import { GridRenderCellParams } from '@mui/x-data-grid-pro'
import { TFunction } from 'react-i18next'

import { FieldModel, ProgramEngagementStatus } from '@cibo/core'
import { useReasonMessages } from '@cibo/ui'
import { Stack } from '@mui/system'

export const fieldTaskEligibilityColumn = ({
  byReasonCode,
  eligibility,
  t,
}: {
  eligibility: ProgramEngagementStatus['status']['eligibility']
  t: TFunction
} & ReturnType<typeof useReasonMessages>) => ({
  field: 'taskEligibility',
  filterable: false,
  sortable: false,
  hideable: false,
  flex: 2,
  disableColumnMenu: true,
  headerName: t('headerName', { ns: '@cibo/programs/fieldTaskEligiblityColumn' }),
  renderCell: (params: GridRenderCellParams<any, FieldModel & { locked: boolean }>) => {
    const allReasons = eligibility?.reasonItems?.filter(
      ({ dataType, id }) => id === params.row.id && dataType === 'field'
    )
    return allReasons?.length ? (
      <Stack py={1}>
        <ul style={{ listStyle: 'disc' }}>
          {allReasons.map(({ reasons, id }) =>
            reasons.map(({ reason, traitId }) => (
              <li key={traitId}>{byReasonCode({ reasonCode: reason, traitId })}</li>
            ))
          )}
        </ul>
      </Stack>
    ) : null
  },
})
